export default __webpack_public_path__ + "static/media/news-check.210c527a.svg";